import domReady from '@wordpress/dom-ready';
import { attachJumpLinks } from './components/jumpLinks';

domReady( () => {
	const links = Array.from(
		document.querySelectorAll< HTMLAnchorElement >( 'a[href*="#"]' )
	);
	attachJumpLinks( links );
} );

domReady( () => {
	const accordionItems = Array.from(
		document.querySelectorAll< HTMLAnchorElement >( '.wp-block-accordion-panel' )
	);

	const setMeasuredHeight = () => {

		accordionItems.forEach( ( item ) => {
			const height = item.scrollHeight;
			item.style.setProperty( '--wp-accordion-panel-height', height + 'px' );
		} );
	}
	
	setMeasuredHeight();
	window.addEventListener( 'resize', setMeasuredHeight );
} );


// domReady( () => {
// 	const responsiveMenus = Array.from(
// 		document.querySelectorAll< HTMLDivElement >( '.wp-block-navigation__responsive-container' )
// 	);

// 	responsiveMenus.forEach( ( responsiveMenu ) => {
// 		console.log(responsiveMenu);		
// 	} );

// } );


// const height = element?.ref?.scrollHeight;
// const currentHeight = parseInt( 
// 	element?.ref?.style?.getPropertyValue( '--classic-menu-block--submenu-height' )
// 	|| '0px'
// );
// if ( currentHeight !== height ) {
// 	element.ref.style.setProperty( '--classic-menu-block--submenu-height', height + 'px' );
// }